import moment from 'moment';
import { ApiKey, ApiUrl, WebUrl, AlertTypes, _MAIN_WALLET_ID } from "../util/Constant";
import { showMessage, setDisplayLogin } from './AppAction';
import { stringIsNullOrEmpty, numberWithCurrencyFormat, createFormBody } from "../util/Util";
import  store  from "../ApplicationStore";
import i18n from '../localization/i18n';

export const _PRODUCT_CATEGORY = "_PRODUCT_CATEGORY";
export const _ROLLOVER_TARGET = "_ROLLOVER_TARGET";
export const _PLAYABLE_CATEGORY = "_PLAYABLE_CATEGORY";
export const _PRODUCT_GAME_ID = '_PRODUCT_GAME_ID';
export const _MASTER_PRODUCT_ID = '_MASTER_PRODUCT_ID';
export const _MASTER_PRODUCT_NAME = '_MASTER_PRODUCT_NAME';
export const _GAME_IS_APP = '_GAME_IS_APP';
export const _GAME_APP_URL = '_GAME_APP_URL';
export const _GAME_APP_DEEP_LINK = '_GAME_APP_DEEP_LINK';
export const _GAME_APP_PACKAGE_NAME_KEYWORD = '_GAME_APP_PACKAGE_NAME_KEYWORD';
export const _WALLET_LIST = '_WALLET_LIST';
export const _PROVIDER_WALLET_DATA = '_PROVIDER_WALLET_DATA';
export const _MP_DATA = '_MP_DATA';
export const _SHOW_PREGAME_POPUP = '_SHOW_PREGAME_POPUP';
export const _SHOW_NON_SEAMLESS_TRANSFER_CONFIRMATION = '_SHOW_NON_SEAMLESS_TRANSFER_CONFIRMATION';



const comingSoonProductGameCode = ["MEGATOGEL"]; // key in the product game code

export const setProductCategory = (productCategory) => {
  return (dispatch) => {
    dispatch({
      type: _PRODUCT_CATEGORY,
      payload: productCategory,
    });
  };
};

export const setRolloverTarget = (rolloverTarget) => {
  return (dispatch) => {
    dispatch({
      type: _ROLLOVER_TARGET,
      payload: rolloverTarget,
    });
  };
};


export const setPlayableCategory = (playableCategory) => {
  return (dispatch) => {
    dispatch({
      type: _PLAYABLE_CATEGORY,
      payload: playableCategory,
    });
  };
};

export const setProductGameId = (id) => {
  return (dispatch) => {
    dispatch({
      type: _PRODUCT_GAME_ID,
      payload: id,
    });
  };
};

export const setMasterProductId = (id) => {
  return (dispatch) => {
    dispatch({
      type: _MASTER_PRODUCT_ID,
      payload: id,
    });
  };
};

export const setMasterProductName = (name) => {
  return (dispatch) => {
    dispatch({
      type: _MASTER_PRODUCT_NAME,
      payload: name,
    });
  };
};


export const setGameIsApp = (isApp) => {
  return (dispatch) => {
    dispatch({
      type: _GAME_IS_APP,
      payload: isApp,
    });
  };
};


export const setGameAppUrl = (url) => {
  return (dispatch) => {
    dispatch({
      type: _GAME_APP_URL,
      payload: url,
    });
  };
};



export const setGameAppDeepLink = (deepLink) => {
  return (dispatch) => {
    dispatch({
      type: _GAME_APP_DEEP_LINK,
      payload: deepLink,
    });
  };
};

export const setGameAppPackageNameKeyword = (keyword) => {
  return (dispatch) => {
    dispatch({
      type: _GAME_APP_PACKAGE_NAME_KEYWORD,
      payload: keyword,
    });
  };
};


export const setWalletList = (walletList) => {
  return (dispatch) => {
    dispatch({
      type: _WALLET_LIST,
      payload: walletList,
    });
  };
};

export const setProviderWalletData = (data) => {
  return (dispatch) => {
    dispatch({
      type: _PROVIDER_WALLET_DATA,
      payload: data,
    });
  };
};

export const setMpData = (data) => {
  return (dispatch) => {
    dispatch({
      type: _MP_DATA,
      payload: data,
    });
  };
};

export const setShowPregamePopup = (show) => {
  return (dispatch) => {
    dispatch({
      type: _SHOW_PREGAME_POPUP,
      payload: show,
    });
  };
};



export const setShowNonSeamlessTransferConfirmation = (show) => {
  return (dispatch) => {
    dispatch({
      type: _SHOW_NON_SEAMLESS_TRANSFER_CONFIRMATION,
      payload: show,
    });
  };
};




// Start game
export const startGame = (productGame) => {
  return async (dispatch) => {
    const { isLoggedIn, userData } = store.getState().authState;
    const { playableCategory } = store.getState().gameState;
    if (isLoggedIn) {
      if (productGame && productGame.gameUm !== true && !(comingSoonProductGameCode.includes(productGame.gameCode) && moment(productGame.parameter_1).isValid() && moment(productGame.parameter_1).isAfter(moment()))) {
        if (userData.isSpecialRollover) {
          let productCategoryListArr = [...playableCategory];
          if (productCategoryListArr.includes(productGame.productCategory.originalTitle)) {
            dispatch(checkIsSeamlessBeforeStart(
              productGame
            ));
          }
          else {
            dispatch(showMessage({
              type: 'INFO',
              content: i18n.t('ROLLOVER_EXIST'),
              onConfirm: () => { },
            }));
          }
        }
        else
        {
          dispatch(checkIsSeamlessBeforeStart(
            productGame
          ));
        }
      } else {
        if (productGame.gameUm === true) {
          dispatch(showMessage({
            type: 'INFO',
            content: i18n.t('GAME_UM'),
            onConfirm: () => { },
          }));
        } else if (productGame && comingSoonProductGameCode.includes(productGame.gameCode) && moment(productGame.parameter_1).isValid() && moment(productGame.parameter_1).isAfter(moment())) {
          dispatch(showMessage({
            type: 'INFO',
            content: i18n.t('COMING_SOON'),
          }));
        }
      }
    } else {
      if (productGame && comingSoonProductGameCode.includes(productGame.gameCode) && moment(productGame.parameter_1).isValid() && moment(productGame.parameter_1).isAfter(moment())) {
        dispatch(showMessage({
          type: 'INFO',
          content: i18n.t('COMING_SOON'),
        }));
      } else {
        dispatch(setDisplayLogin(true));
      }
    }
  };
};

// check is seamless before start
const checkIsSeamlessBeforeStart = (productGame) => {
  return async (dispatch) => {
    if (productGame.product.isSeamless === false) {
      dispatch(setProductGameId(productGame.id));
      dispatch(setShowNonSeamlessTransferConfirmation(true));
      dispatch(setMasterProductId(productGame.product.id));
      dispatch(setMasterProductName(productGame.product.productName));
      dispatch(setGameIsApp(productGame.isApp));
      dispatch(setGameAppDeepLink(productGame.appDeepLink));
      dispatch(setGameAppPackageNameKeyword(productGame.packageNameKeyword));

      if (productGame.isApp && !stringIsNullOrEmpty(productGame.appUrl)) {
        dispatch(setGameAppUrl(productGame.appUrl));
      }
    } else {
      //enterGame(productGame.id, productGame.isApp, productGame.isNewWindow)
      enterGame(productGame.id, productGame.product.productName, productGame.isApp, productGame.isNewWindow)
    }
  }
}

// Enter game
export const enterGame = async (id, productName, isApp, isNewWindow) => {
  //window.open(ApiUrl._API_START_GAME + "?gameId=" + id + "&isApp=" + (isApp ? 1 : 0) + "&device="+ (isApp ? "m" : "d"));
  if (!window.ReactNativeWebView) {
    window.open(ApiUrl._API_START_GAME + "?gameId=" + id + "&isApp=" + (isApp ? 1 : 0) + "&device=m" );
  } else {
    if (isNewWindow === true) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          url: `${process.env.REACT_APP_ENDPOINT_URL || window.location.origin
            }${ApiUrl._API_START_GAME}?gameId=${id}&device=m`,
        })
      );
    } else {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          url: `${process.env.REACT_APP_ENDPOINT_URL || window.location.origin
            }${WebUrl._URL_GAME_PAGE}?gameId=${id}&productName=${productName}`,
        })
      );
    }
  }

}